import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import TopNav from './components/topNav';
import SideNav from './components/sideNav';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './components/dashboard';
import About from './components/about';
import Contact from './components/contact';
import HospitalLocation from './components/hospitalLocation';
import DoctorName from './components/doctorName';

function App() {
  return (
    <div>
      <TopNav />
      <div>
        <div className="d-flex">
          <BrowserRouter>
              <SideNav />
              <Routes className="App">
                <Route path="/" element={<Dashboard name1="Investigation" name2="GRN" name3="op Module" name4="UMR"/>} />
                <Route path="/about" element={<About />} />
                <Route path="/location" element={<HospitalLocation />} />
                <Route path="/doctor-name" element={<DoctorName />} />

                <Route path="/contact" element={<Contact />} />
              </Routes>
            </BrowserRouter>  
        </div>
      </div>
    </div>
  );
}

export default App;
